class oDelivery extends HTMLDivElement {
    constructor() {
        super();
        this.dosSection = this.querySelector('[data-delivery-on-slot]');
        this.radioInputs = [...this.querySelectorAll('input[type="radio"].delivery-radio')];
        this.radioInputs.forEach((radioEl) => {
            radioEl.addEventListener('change', this.updateSelectionState.bind(this));
        });
        this.updateBorderState();
        this.updateSelectionState();
    }

    /**
     * General update of the component needed to be done after a radio button selection
     */
    updateSelectionState() {
        this.radioInputs.forEach((radio) => {
            const card = radio.closest('.delivery-selector-item');
            card.classList.toggle('selected', radio.checked);

            // Setup edit button
            const editButton = card.querySelector('button.address-card-edit');
            if (editButton) {
                if (radio.checked) {
                    editButton.removeAttribute('tabindex');
                } else {
                    editButton.setAttribute('tabindex', -1);
                }
            }

            if (radio.checked && this.dosSection && ('displayDeliveryOnSlot' in radio.dataset)) {
                card.append(this.dosSection);
            }

            // Manually set Shipping method input (for base SFRA compatibility)
            if (radio.checked) {
                const shippingMethodInput = document.getElementById('shippingMethodID');
                shippingMethodInput.value = radio.dataset.shippingId;
            }
        });
    }

    /**
     * Update border display
     * TODO: could be done staticly via ISML
     */
    updateBorderState() {
        const items = [...this.querySelectorAll('.delivery-selector-item')];
        items.forEach((item) => item.classList.remove('first-card-item', 'last-card-item'));

        const visibleItems = items.filter((item) => window.getComputedStyle(item).getPropertyValue('display') !== 'none');
        if (visibleItems.length > 0) {
            visibleItems[0].classList.add('first-card-item');
            visibleItems[visibleItems.length - 1].classList.add('last-card-item');
        }
    }
}

customElements.define('o-delivery', oDelivery, {
    extends: 'div',
});
